import Magnetic from "@/components/Magnetic";
import { motion } from "framer-motion";
import New_Logo from "./New_Logo";

const Footer = () => {
  return (
    <footer className="border-t border-white/5 py-12 bg-background relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex flex-col items-center md:items-start gap-4">
            <Magnetic strength={0.2}>
              <a href="#home" className="block">
                <New_Logo />
              </a>
            </Magnetic>
            <p className="font-body text-xs text-foreground-muted tracking-wider">
              Powering the next generation of AI-driven communication.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-2">
            <p className="font-body text-xs text-foreground-muted">
              © {new Date().getFullYear()} PulseChat.ai. Built for the future.
            </p>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              className="flex items-center gap-1.5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-pulse animate-pulse shadow-[0_0_8px_hsl(var(--pulse))]" />
              <span className="font-body text-[10px] text-pulse/80 uppercase tracking-widest font-bold">Node Active</span>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
